import { render, staticRenderFns } from "./UserExtraFields.vue?vue&type=template&id=ccb0b2a8&"
import script from "./UserExtraFields.vue?vue&type=script&lang=js&"
export * from "./UserExtraFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports